export default __webpack_public_path__ + "static/media/check-solid.02253888.svg";